import { returnInitialStore, returnFinishGameStore } from '../../assets/utils/initStore';
import Vue from 'vue';
import * as THREE from 'three';

const state = returnInitialStore()

const mutations = {
  COMPLETE_OBJECT(state, payload) {
    let { roomIndex, objectIndex, selectedIndex, correctIndex, isCorrect } = payload;

    if (this.$ga) {
      let uppercaseName = state.selected.charAt(0).toUpperCase() + state.selected.slice(1)
      this.$ga.event({
        eventCategory: uppercaseName,
        eventAction: 'completed',
        eventLabel: state.rooms[roomIndex].name
      });
    }

    let currentRoomScore = state.rooms[roomIndex].score;

    // use map to create whole new state array - this triggers store update?
    state.rooms = state.rooms.map((room, index) => {
      let tempRoom = room;


      if (tempRoom.name === state.rooms[roomIndex].name) {
        // update this specific entry
        tempRoom.questions[objectIndex].completed = true;
        tempRoom.questions[objectIndex].selectedIndex = selectedIndex;
        tempRoom.questions[objectIndex].correctIndex = correctIndex;
        tempRoom.questions[objectIndex].isCorrect = isCorrect;
        tempRoom.score = isCorrect ? currentRoomScore + 1 : currentRoomScore;
      }

      return tempRoom;

    });

    state.totalScore = isCorrect ? state.totalScore + 1 : state.totalScore;

    Vue.set(state, 'questionsCompleted', state.questionsCompleted + 1);

  },
  RE_SET_ROOMS_DATA(state) {
    let newState = returnInitialStore();
    newState.residential.meshes = new Map(state.residential.meshes);
    newState.residential.textures = new Map(state.residential.textures);
    newState.commercial.meshes = new Map(state.commercial.meshes);
    newState.commercial.textures = new Map(state.commercial.textures);

    Object.assign(state, newState);

    Vue.set(state, 'questionsCompleted', 0);
    Vue.set(state, 'totalScore', 0);

    console.log('%c RELOADED STATE:  ', 'background: #DDDDDD; color: #000000', state);
  },
  SET_CLICKED_OBJ(state, payload) {
    let { nextQuestionRoomIndex, nextQuestionIndex } = payload;

    Vue.set(state, 'clickedObj', state.rooms[nextQuestionRoomIndex].questions[nextQuestionIndex]);

  },

  SWITCH_BUILDING(state, payload) {
    state.selected = payload;
  }
}

const getters = {
  getCommercial: (state) => state.commercial,
  getResidential: (state) => state.residential,
  getRooms: (state) => state.rooms,
  getMeshes: (state) => state.meshes,
  getTextures: (state) => state.textures,
  getTotalQuestionsCorrect: state => state.totalScore,
  getFinalScoreRoomsData: state => {

    let finalScoreRoomsData = state.rooms.map(room => {
      let tempRoomData = {
        name: null,
        score: null,
        totalQuestions: null,
      };

      tempRoomData.name = room.name;
      tempRoomData.score = room.score;
      tempRoomData.totalQuestions = room.totalQuestions;

      return tempRoomData;
    });

    return finalScoreRoomsData;
  },
  getTotalQuestionsCompleted: state => state.questionsCompleted,
  getQuestionByIds: (state) => (roomId, questionId) => {
    if (state.rooms.length < roomId) {
      return null
    }
    if (state.rooms[roomId] === null || state.rooms[roomId] === undefined) {
      return null
    }
    if (state.rooms[roomId].questions === null || state.rooms[roomId].questions === undefined) {
      return null
    }
    if (state.rooms[roomId].questions.length < questionId) {
      return null
    }
    return state.rooms[roomId].questions[questionId]
  },
  getQuestionsById: (state) => (roomId) => {
    if (state.rooms.length < roomId) {
      return null
    }
    if (state.rooms[roomId] === null || state.rooms[roomId] === undefined) {
      return null
    }
    return state.rooms[roomId].questions
  },
  getClickedObj: (state) => (state.clickedObj),
  getQuestions: state => (roomId) => (state.rooms[roomId].questions),
  getSelected: state => state.selected
}

const actions = {
  addObjects({ commit, state }, payload) {
    for (let roomIndex = 0; roomIndex < state.rooms.length; roomIndex++) {
      for (let questionIndex = 0; questionIndex < state.rooms[roomIndex].questions.length; questionIndex++) {
        if (state.rooms[roomIndex].questions[questionIndex].hasOwnProperty('position')) {
          const questionPos = new THREE.Vector3(
            state.rooms[roomIndex].questions[questionIndex].position.x,
            state.rooms[roomIndex].questions[questionIndex].position.y,
            state.rooms[roomIndex].questions[questionIndex].position.z)

          commit('ADD_OBJECT', { roomIndex: roomIndex, position: questionPos })
        }
      }
    }
  },
  completeObject({ commit }, payload) {
    commit('COMPLETE_OBJECT', payload);
  },
  setClickedObj({ commit }, payload) {
    // debugger;
    commit('SET_CLICKED_OBJ', payload);
  },
  setRoomsDataForPlayAgain({ commit }, payload) {
    commit('RE_SET_ROOMS_DATA');
  },
  switchBuilding({ commit }, payload) {
    commit('SWITCH_BUILDING', payload);
  }
}

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/Rooms.js